var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSendLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7573 5.34165C19.0567 5.64108 19.1543 6.08125 19.0264 6.50735L19.0251 6.51173L15.6251 17.5117L15.6229 17.5186C14.9087 19.7262 11.8405 19.7262 11.1263 17.5186L11.1244 17.5126L10.0602 14.0887L6.6303 13.0226C4.4227 12.3084 4.42272 9.24024 6.63031 8.52601L6.63433 8.52471L17.5843 5.07473L17.5916 5.0725C18.0177 4.94467 18.4578 5.04222 18.7573 5.34165ZM17.9103 6.12533L6.96705 9.57321C5.77745 9.95978 5.77714 11.5879 6.96612 11.9751L10.6629 13.1241C10.8357 13.1778 10.9711 13.3132 11.0248 13.4861L12.1738 17.1828C12.5609 18.3713 14.1879 18.3715 14.5753 17.1832L17.9733 6.18968C17.9848 6.15049 17.9814 6.12921 17.98 6.12318C17.9796 6.12177 17.9793 6.12068 17.9791 6.11987C17.9782 6.1196 17.9772 6.11928 17.9757 6.11895C17.9698 6.11758 17.9488 6.11421 17.9103 6.12533Z",
    fill: "#9FA4AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2391 10.6382L10.8891 13.9882L10.1113 13.2104L13.4613 9.86035L14.2391 10.6382Z",
    fill: "#9FA4AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSendLight);
export default __webpack_public_path__ + "static/media/icon_send_light.c8495eb7.svg";
export { ForwardRef as ReactComponent };